/* tslint:disable */
/* eslint-disable */
/**
 * Actors API
 * API for managing actors, including legal and physical persons.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Subsidiary declared under a parent legal entity. It is a line of the parent, not a legal entity itself.
 * @export
 * @interface SubsidiaryDto
 */
export interface SubsidiaryDto {
    /**
     * 
     * @type {string}
     * @memberof SubsidiaryDto
     */
    id: string;
    /**
     * Name of the subsidiary
     * @type {string}
     * @memberof SubsidiaryDto
     */
    companyName: string;
    /**
     * SIRET number of the subsidiary
     * @type {string}
     * @memberof SubsidiaryDto
     */
    registrationNumber: string;
    /**
     * Revenue of the last closed fiscal year, in euros
     * @type {number}
     * @memberof SubsidiaryDto
     */
    revenue: number;
    /**
     * Number of employees
     * @type {number}
     * @memberof SubsidiaryDto
     */
    employeesCount: number;
    /**
     * Date calendaire "yyyy-MM-dd". L\'heure est ignorée par le back, aucune conversion de fuseau n\'est appliquée.
     * @type {string}
     * @memberof SubsidiaryDto
     */
    fiscalYearEnd: string;
    /**
     * Existing legal entity the subsidiary is attached to. When set, companyName and registrationNumber cannot be modified.
     * @type {string}
     * @memberof SubsidiaryDto
     */
    legalPersonId?: string | null;
}

/**
 * Check if a given object implements the SubsidiaryDto interface.
 */
export function instanceOfSubsidiaryDto(value: object): value is SubsidiaryDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('companyName' in value) || value['companyName'] === undefined) return false;
    if (!('registrationNumber' in value) || value['registrationNumber'] === undefined) return false;
    if (!('revenue' in value) || value['revenue'] === undefined) return false;
    if (!('employeesCount' in value) || value['employeesCount'] === undefined) return false;
    if (!('fiscalYearEnd' in value) || value['fiscalYearEnd'] === undefined) return false;
    return true;
}

export function SubsidiaryDtoFromJSON(json: any): SubsidiaryDto {
    return SubsidiaryDtoFromJSONTyped(json, false);
}

export function SubsidiaryDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubsidiaryDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'companyName': json['companyName'],
        'registrationNumber': json['registrationNumber'],
        'revenue': json['revenue'],
        'employeesCount': json['employeesCount'],
        'fiscalYearEnd': json['fiscalYearEnd'],
        'legalPersonId': json['legalPersonId'] == null ? undefined : json['legalPersonId'],
    };
}

export function SubsidiaryDtoToJSON(json: any): SubsidiaryDto {
    return SubsidiaryDtoToJSONTyped(json, false);
}

export function SubsidiaryDtoToJSONTyped(value?: SubsidiaryDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'companyName': value['companyName'],
        'registrationNumber': value['registrationNumber'],
        'revenue': value['revenue'],
        'employeesCount': value['employeesCount'],
        'fiscalYearEnd': value['fiscalYearEnd'],
        'legalPersonId': value['legalPersonId'],
    };
}

